import config from "../config";

const storageName = `${config.localStorageName}-searchField`;

export const getSearchField = () => {
    const searchField = localStorage.getItem(storageName);

    try {
        if (searchField) {
            return searchField;
        }
        else {
            return "name";
        }
        throw new Error("");
    }
    catch (err) {
        return null;
    }
};

export const setSearchField = searchField => localStorage.setItem(storageName, searchField);



// WEBPACK FOOTER //
// ./src/services/searchField.js